import { render, staticRenderFns } from "./AutomationRestored.vue?vue&type=template&id=72fa0f8b&scoped=true"
import script from "./AutomationRestored.vue?vue&type=script&lang=js"
export * from "./AutomationRestored.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72fa0f8b",
  null
  
)

export default component.exports